import React from 'react'

import {
    AdUnitWrapperProps,
    AdUnitWrapper,
} from '../../advertising/AdUnit/AdUnitWrapper'
import { createRegisterableComponent } from '@news-mono/web-common'
import { AdDefinition } from '@news-mono/web-common'

export type AdUnitRouteProps = Omit<AdUnitWrapperProps, 'onEvent'> & {
    slot: AdDefinition
}

export const AdUnitRegistration = createRegisterableComponent(
    'ad-unit',
    (props: AdUnitRouteProps, services) => {
        return (
            <AdUnitWrapper
                adState={services.adState}
                unitId={props.slot.id}
                onEvent={services.onEvent}
                breakout={props.breakout}
                hiddenUntilLoaded={props.hiddenUntilLoaded}
                noticePosition={props.noticePosition}
                padding={props.padding}
                stickyOffset={props.stickyOffset}
                unitRendered={props.unitRendered}
            />
        )
    },
)
